import {
  validateExtensions,
} from '../utils/validateFiles'

const extensions = ['.doc', '.docx', '.pdf', '.ppt', '.xls', '.xlsx', '.jpg', '.png', '.jpeg', '.zip']
const uploadFileList = $('.js-uploadFileList')
const uploadFileInput = $('.js-uploadFileInput')

uploadFileInput.on('change', (event) => {
  const { files } = event.target

  $.each(files, (i, file) => {
    if (validateExtensions(file, extensions)) {
      generateTemplate(file)
    }
  })
})

$(document).on('click', '.js-fileDelete', (event) => {
  const current = $(event.currentTarget)

  current.parent().remove()
})

function generateTemplate(file) {
  const reader = new FileReader()

  reader.onload = function () {
    const dataURL = reader.result

    const tpl = `
      <div class="form-file-elem">
          <input type="file" name="files[]" value="${dataURL}" />
          <div class="form-file-elem__title">${file.name}</div>
          <div class="form-file-elem__del js-fileDelete">
            <svg class="icon icon-delete ">
              <use xlink:href="images/sprites.svg#delete"></use>
            </svg>
          </div>
      </div>
    `

    uploadFileList.append(tpl)
  }
  reader.readAsDataURL(file)
}
